/**
 * WorkDocEditor — Core TipTap Editor Wrapper
 *
 * Wraps @tiptap/react EditorContent and provides the editor instance
 * to parent components via onEditorReady callback.
 */
import { useEditor, EditorContent } from "@tiptap/react";
import { getExtensions } from "./WorkDocExtensions";

export default function WorkDocEditor({
  content = "",
  onEditorReady,
  onUpdate,
  placeholder = "Start writing...",
  editable = true,
  maxLength = 100000,
  editorRef,
}) {
  const editor = useEditor({
    extensions: getExtensions({ placeholder, limit: maxLength }),
    content,
    editable,
    onUpdate: ({ editor: ed }) => {
      if (onUpdate) {
        onUpdate({
          html: ed.getHTML(),
          json: ed.getJSON(),
          text: ed.getText(),
          wordCount: ed.storage?.characterCount?.words?.() || 0,
          charCount: ed.storage?.characterCount?.characters?.() || 0,
        });
      }
    },
    onSelectionUpdate: ({ editor: ed }) => {
      if (onUpdate) {
        onUpdate({
          html: ed.getHTML(),
          json: ed.getJSON(),
          text: ed.getText(),
          wordCount: ed.storage?.characterCount?.words?.() || 0,
          charCount: ed.storage?.characterCount?.characters?.() || 0,
        });
      }
    },
    editorProps: {
      attributes: {
        class:
          "prose prose-invert max-w-none focus:outline-none min-h-[400px] px-8 py-6 workdoc-editor-content",
      },
    },
  });

  // Expose editor instance to parent
  if (editor && onEditorReady) {
    onEditorReady(editor);
  }
  if (editor && editorRef) {
    editorRef.current = editor;
  }

  return (
    <div className="workdoc-editor-wrapper bg-white shadow-sm rounded-sm">
      <EditorContent editor={editor} />
    </div>
  );
}
